<div class="add-custom-image">
  <div class="flex flex-row items-center justify-between">
    <div>
      <div class="mat-subtitle-2 fw-600 fs-24">{{edit ? ('CUSTOM_IMAGES.EDIT_COMPONENT' | transloco) : ('CUSTOM_IMAGES.ADD_COMPONENT' | transloco)}}</div>
    </div>
    <div>
      <mat-icon class="justify-items-end cursor-pointer icon-md" (click)="closeSidenav()" svgIcon="close"></mat-icon>
    </div>
  </div>
  <mat-divider class="neutral-2 mt-12 mb-12"></mat-divider>
  <div class="add-section">
    <div class="flex flex-col pt-16 pb-24">
      <div class="flex flex-row justify-start items-center mb-6">
        <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'CUSTOM_IMAGES.COMPONENT_NAME' | transloco | uppercase }}</label>
        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'CUSTOM_IMAGES.COMPONENT_NAME' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <mat-select (closed)="dropdownClose()" [formControl]="componentForm.get('component')" class="fw-500 form-sel fs-16 envt-dropdown" placeholder="{{'CUSTOM_IMAGES.CHOOSE_COMPONENT' | transloco}}" panelClass="component-dropdown" (click)="resetFilter()" (selectionChange)="selectionChanged($event)">
        <div class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
          <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
        </div>
        <mat-option class="fs-14 flex justify-center" *ngIf="filteredComponents?.length === 0">{{'CUSTOM_IMAGES.NO_COMPONENT_FOUND' | transloco}}</mat-option>
        <mat-option *ngFor="let version of filteredComponents" [value]="version.name">{{version.name}}</mat-option>
      </mat-select>
      <app-error [control]="componentForm.get('component')"></app-error>
    </div>

    <div class="image-pack p-16">
      <div class="flex justify-between items-center">
        <div class="mat-body-1 fw-600">{{'CUSTOM_IMAGES.IMAGES' | transloco }}</div>
        <button type="button" class="flex justify-center image-add items-center mat-subtitle-2" mat-button
          (click)="addImageOccurrence()">
          <mat-icon svgIcon="add" class="icon-md pr-4"></mat-icon>
          {{'BUTTONS.ADD' | transloco }}
        </button>
      </div>
    
      <div class="flex flex-row header mt-18">
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.NAME' | transloco | uppercase }}</div>
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.PATH' | transloco | uppercase }}</div>
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.TAG' | transloco | uppercase }}</div>
      </div>
      <div *ngIf="!imageOccurrences || imageOccurrences?.length === 0">
        <div class="no-data flex items-center justify-center">{{'CUSTOM_IMAGES.NO_DATA_AVAILABLE' | transloco }}</div>
      </div>
      <ng-container *ngFor="let occurrence of imageOccurrences; let i = index">
        <form [formGroup]="imageForm[occurrence]" class="media-form">
          <div class="flex flex-row pl-16 pt-16 pb-16 image">
            <div class="flex flex-col image-form mr-16">
              <input formControlName="name" placeholder="{{'CUSTOM_IMAGES.NAME' | transloco}}" class="fw-500" required>
              <app-error [control]="imageForm[occurrence]?.get('name')"></app-error>
            </div>
            <div class="flex flex-col image-form mr-16">
              <input formControlName="path" placeholder="{{'CUSTOM_IMAGES.PATH' | transloco}}" class="fw-500" required>
              <app-error [control]="imageForm[occurrence]?.get('path')"></app-error>
            </div>
            <div class="flex flex-col image-form mr-16">
              <input formControlName="version" placeholder="{{'CUSTOM_IMAGES.TAG' | transloco}}" class="fw-500" required>
              <app-error [control]="imageForm[occurrence]?.get('version')"></app-error>
            </div>
            <div class="flex flex-row justify-end items-center fw-500 ml-8">
              <mat-icon (click)="deleteImageOccurrence(i)" class="mr-4 icon-md-2 cursor-pointer delete" svgIcon="delete"></mat-icon>
            </div>
          </div>
        </form>
      </ng-container>
    </div>


    <div class="image-pack p-16 mt-24">
      <div class="flex justify-between items-center">
        <div class="mat-body-1 fw-600">{{'CUSTOM_IMAGES.PACKAGES' | transloco }}</div>
        <button type="button" class="flex justify-center image-add items-center mat-subtitle-2" mat-button
          (click)="addPackageOccurrence()">
          <mat-icon svgIcon="add" class="icon-md pr-4"></mat-icon>
          {{'BUTTONS.ADD' | transloco }}
        </button>
      </div>
    
      <div class="flex flex-row header mt-18">
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.NAME' | transloco | uppercase }}</div>
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.PATH' | transloco | uppercase }}</div>
        <div class="mat-subtitle-2 fw-700 fs-12 header-label mr-16 pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.TAG' | transloco | uppercase }}</div>
      </div>
      <div *ngIf="!packageOccurrences || packageOccurrences?.length === 0">
        <div class="no-data flex items-center justify-center">{{'CUSTOM_IMAGES.NO_DATA_AVAILABLE' | transloco }}</div>
      </div>
      <ng-container *ngFor="let occurrence of packageOccurrences; let i = index">
        <form [formGroup]="packageForm[occurrence]" class="media-form">
          <div class="flex flex-row pl-16 pt-16 pb-16 image">
            <div class="flex flex-col image-form mr-16">
              <input formControlName="name" placeholder="{{'CUSTOM_IMAGES.NAME' | transloco}}" class="fw-500" required>
              <app-error [control]="packageForm[occurrence]?.get('name')"></app-error>
            </div>
            <div class="flex flex-col image-form mr-16">
              <input formControlName="path" placeholder="{{'CUSTOM_IMAGES.PATH' | transloco}}" class="fw-500" required>
              <app-error [control]="packageForm[occurrence]?.get('path')"></app-error>
            </div>
            <div class="flex flex-col image-form mr-16">
              <input formControlName="version" placeholder="{{'CUSTOM_IMAGES.TAG' | transloco}}" class="fw-500" required>
              <app-error [control]="packageForm[occurrence]?.get('version')"></app-error>
            </div>
            <div class="flex flex-row justify-end items-center fw-500 ml-8">
              <mat-icon (click)="deletePackageOccurrence(i)" class="mr-4 icon-md-2 cursor-pointer delete" svgIcon="delete"></mat-icon>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>

    
  <span class="flex-auto mb-10"></span>
  <mat-divider class="neutral-2 mt-16 mb-16"></mat-divider>
  <div class="footer" >
    <div class="flex flex-row justify-end pb-16">
      <button class="flex justify-items-center items-center cancel-btn mr-16 pr-16 pl-16 pt-8 pb-8" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" (click)="createDeployment()" type="button">{{edit ? ('BUTTONS.SAVE' | transloco) : ('BUTTONS.ADD' | transloco)}}</button>
    </div>
  </div>
</div>



